import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useGetSelectedEvent from '../hooks/useGetSelectedEvent';
import useGetParams from '../hooks/useGetParams';
import AdminSectionTitle from './AdminSectionTitle';
import ShowtimesTable from './ShowtimesTable';
import CustomModal from './atoms/CustomModal';
import CreateEditShowtime from './CreateEditShowtime';
import OrdersTableSkeleton from './OrdersTableSkeleton';
import { useGetShowtimesQuery } from '../store';

const AdminShowtimes: React.FC = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const { event } = useGetSelectedEvent();
  const { eventId, businessId } = useGetParams();

  const { data: showtimes, isFetching } = useGetShowtimesQuery({
    businessId,
    eventId,
  }, {
    skip: !businessId || !eventId,
  });

  const handleSuccessAddShowtime = () => {
    setShowModal(false);
  };

  const handleAddShowtime = () => {
    setShowModal(true);
  };

  return (
    <div className="flex flex-col gap-8 my-6">
      <AdminSectionTitle
        title="Eventos"
        subtitle={`${event?.name} - Funciones`}
        mainButtons={[{
          label: 'Entradas',
          onClick: () => navigate('../tickets'),
          variant: 'secondary',
          image: '/ticket-01.svg',
          hidden: !event?.has_showtimes,
        }]} />
      <div>
        {isFetching && <OrdersTableSkeleton />}
        {showtimes && (
          <ShowtimesTable
            showtimes={showtimes}
            eventId={eventId}
            businessId={businessId}
            button={{
              label: 'Crear nueva función',
              image: '/ticket-01.svg',
              onClick: handleAddShowtime,
              variant: 'secondary',
            }}
          />
        )}
      </div>
      <CustomModal
        onRequestClose={() => setShowModal(false)}
        isOpen={showModal}
        hideCancelButton
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <h1 className="text-xl font-medium">Crear función</h1>
            <p className="text-text-tertiary text-sm">
              Podrás realizar las ediciones que necesites en esta función
            </p>
          </div>
          <CreateEditShowtime onSuccess={handleSuccessAddShowtime} onCancel={() => setShowModal(false)} />
        </div>
      </CustomModal>
    </div>
  );
};

export default AdminShowtimes;
